import { render, staticRenderFns } from "./SelectTeamChannel.vue?vue&type=template&id=25760f6c"
import script from "./SelectTeamChannel.vue?vue&type=script&lang=js"
export * from "./SelectTeamChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25760f6c')) {
      api.createRecord('25760f6c', component.options)
    } else {
      api.reload('25760f6c', component.options)
    }
    module.hot.accept("./SelectTeamChannel.vue?vue&type=template&id=25760f6c", function () {
      api.rerender('25760f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectTeamChannel.vue"
export default component.exports